export const PhoneValidation = new RegExp(
  /^(\d)?\D*?(\d{3})\D*(\d{3})\D*(\d{4})\D*(\d{0,6})/
);
